import { motion } from "framer-motion";
import { Star } from "lucide-react";

const HEADS = [
  "https://images.unsplash.com/photo-1769636929231-3cd7f853d038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4Mzg2MzIzMHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1758534063829-a72058381e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4Mzg2MzIzMHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4Mzg2MzIzMHww&ixlib=rb-4.1.0&q=85",
];

const items = [
  {
    quote: "I shipped my first App Store app in a weekend. ArcaCentum turned a rough idea into a live product before Monday.",
    name: "Maya Okafor",
    role: "Indie Founder · Streaksly",
  },
  {
    quote: "The niche finder alone paid for itself. We found a gap, built the app, and hit #4 in Productivity in three weeks.",
    name: "Daniel Reyes",
    role: "Growth Lead · NorthPeak",
  },
  {
    quote: "It genuinely feels like having a senior product team on tap. The generated apps are clean and actually native.",
    name: "Priya Nair",
    role: "Solo Developer",
  },
];

export default function Testimonials() {
  return (
    <section className="py-28 md:py-36 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4">/ loved by builders</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight leading-[1.05]">
            Founders are shipping faster than ever.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="rounded-3xl border border-white/10 bg-[#0a0a0a] p-8 flex flex-col justify-between hover:border-[#0055FF]/40 transition-colors duration-300"
              data-testid={`testimonial-${i}`}
            >
              <div>
                <div className="flex gap-1 mb-5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={15} className="fill-[#00F0FF] text-[#00F0FF]" />
                  ))}
                </div>
                <blockquote className="text-slate-200 text-lg leading-relaxed">"{t.quote}"</blockquote>
              </div>
              <figcaption className="flex items-center gap-3 mt-8">
                <img src={HEADS[i]} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-white/10" />
                <div>
                  <div className="font-display font-semibold text-white">{t.name}</div>
                  <div className="font-mono text-xs text-slate-500">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
